import React from "react";
import InboxTable from "pages/Messages/Inbox/Table";
import { Container } from "pages/Messages/Inbox/InboxStyled";
import { MobileHeader } from "assets/css/globle";
import { MsgToSelectedCarsCmp } from "commonComponents/SideNav/subSectionNav/Map/commonFunctionalities/MsgToSelectedCars";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useHookstate } from "@hookstate/core";
import {
  MESSAGE_FLEET_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "100%",
  bgcolor: "background.paper",
  borderRadius: "5px",
};

export const Inbox = () => {
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const { isLoading } = useHookstate(MESSAGE_FLEET_GLOBAL_STATES);
  const handleCloseMsg = () => {
    isLoading.set(false);
  };

  useEffect(() => {
    if (siteId.get() !== null) {
      dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
    }
  }, [siteId.get()]);
  return (
    <Container>
      <MobileHeader>
        <h4>Inbox</h4>
      </MobileHeader>
      <InboxTable />
      <Modal
        open={isLoading.get()}
        onClose={handleCloseMsg}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <MsgToSelectedCarsCmp cancelClick={handleCloseMsg} />
        </Box>
      </Modal>
    </Container>
  );
};
